import axiosCall from './interceptor';
import URL from '../helper';

export const addTeam = async payload => {
  const url = `${URL.BASE_URL}rgroup`;
  let response = await axiosCall('post', url, payload, false);
  return response.data;
};

export const deleteTeam = async payload => {
  const url = `${URL.BASE_URL}rgroup?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const updateTeam = async payload => {
  const url = `${URL.BASE_URL}rgroup`;
  let response = await axiosCall('put', url, payload, false);
  return response.data;
};

export const getAllTeams = async () => {
  const url = `${URL.BASE_URL}rgroup`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getGroupPermission = async (userOnly = false) => {
  let url = `${URL.BASE_URL}rgrouppermission`;
  if (userOnly) {
    url = `${URL.BASE_URL}rgrouppermissionForUser`;
  }
  let response = await axiosCall('get', url);
  let result = response.data;
  if (userOnly && result?.data) {
    result.data = result.data.filter(a => a.permission === 'write');
  }
  return result;
};
